<template>
    <div id="app_header">

        <h3>Header</h3>

    </div>
</template>

<script>

    export default {
        props: []
        , components: {}
        , mounted() {
            this.init();
        }
        , data() {
            return {}
        }
        , watch: {}
        , methods: {
            init() {

            }
        }
        , computed: {}
    }

</script>

<style scoped>

    #app_header {

    }

</style>
